export type NonEmptyArray<T> = [T, ...T[]];

/**
 * Groups an array of items by a key function and returns an array of [key, items] pairs, retaining the original
 * order of the keys as they appear in the input array.
 * Like _.groupBy but returns an array of [key, items] pairs instead of an object.
 */
export function groupBySorted<T extends string | number, K>(
  array: K[],
  keyFn: (item: K) => T,
): [key: T, items: K[]][] {
  const map = new Map<T, K[]>();

  for (const item of array) {
    const key = keyFn(item);
    const group = map.get(key);
    if (group) {
      group.push(item);
    } else {
      map.set(key, [item]);
    }
  }

  return Array.from(map.entries());
}
